import {
  Button,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@barfacil/barfacil-ui'
import { CirclePlus } from 'lucide-react'
import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { TicketComboType } from '@/api/_schemas/management'
import { ComboProductsTable } from '@/app/panel/management/price-list/_components/combo-products-table'
import { FormUpdateProduct } from '@/app/panel/management/price-list/_schemas/update-product'

export const UpdateProductComboForm = () => {
  const form = useFormContext<FormUpdateProduct>()

  const isEmptyComboList = useMemo(
    () => !!form.formState.errors.produto_combo_list,
    [form.formState.errors.produto_combo_list],
  )

  const ticketComboTypesArray: [string, TicketComboType][] = Object.entries(
    TicketComboType,
  )
    .filter(
      ([key, value]) => isNaN(Number(key)) && value !== TicketComboType.Vazio,
    )
    .map(([key, value]) => [key, value] as [string, TicketComboType])

  function handleNewProductFocus() {
    document.getElementById('add-combo-product-combobox')?.click()
  }

  return (
    <div className="flex flex-col gap-4 sm:gap-2">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-2 lg:grid-cols-3">
        <FormField
          control={form.control}
          name="tipo_ticket_combo"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Tipo ticket combo</FormLabel>

              <Select
                onValueChange={field.onChange}
                defaultValue={(!!field.value &&
                (field.value as TicketComboType) !== TicketComboType.Vazio
                  ? field.value
                  : ''
                ).toString()}
              >
                <FormControl>
                  <SelectTrigger
                    autoFocus
                    disabled={form.formState.isSubmitting}
                  >
                    <SelectValue placeholder="Selecione o tipo do ticket combo" />
                  </SelectTrigger>
                </FormControl>

                <SelectContent>
                  <SelectGroup>
                    {ticketComboTypesArray.map(([key, value]) => (
                      <SelectItem
                        className="flex gap-1"
                        key={key}
                        value={value.toString()}
                      >
                        {key}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>

              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <div>
        <aside className="mb-1 mt-4 flex flex-1 items-center gap-1">
          <h3 className="line-clamp-2 text-blue-400">
            ADICIONAR PRODUTOS NO COMBO
          </h3>

          <Button
            variant="ghost"
            size="icon"
            className="mr-1 size-5 max-sm:hidden"
            onClick={handleNewProductFocus}
          >
            <CirclePlus size={20} className="text-sky-500" />
          </Button>
        </aside>

        <ComboProductsTable isEmptyComboList={isEmptyComboList} />
      </div>
    </div>
  )
}
